/**
 * 관리자 메뉴. 원본 home.php 의 $menus 배열을 그대로 옮긴 것이다.
 *
 * !! 이 파일은 scripts/gen-menu.py 가 만든다. 직접 고치지 말 것.
 *    원본이나 리포트 정의가 바뀌면:  python3 scripts/gen-menu.py
 *
 * 예외 1: 맨 끝 '설정' 섹션은 home.php 에 없는 신규 기능이라 gen-menu.py 의
 * NEW_SECTIONS 가 만든다. 이 환경에 레거시 home.php 사본이 있긴 하지만(2026-08-07
 * 자, /home/sbanana/xadmin) 실제로 돌려 보니 라이브 운영 home.php 와 어긋나
 * (중복/사용중단 항목이 다시 섞여 나옴) 정식 소스로 못 쓴다 - 그래서 지금은
 * 스크립트 쪽만 고치고 결과물인 이 파일엔 같은 내용을 손으로 옮겨 뒀다. 다음에
 * 운영 home.php 를 직접 볼 수 있는 곳에서 스크립트를 돌리면 그대로 재생성된다.
 *
 * 예외 2: '통계'(옛 'xadm 통계') 섹션과 '물류센터'에 옮겨 붙은 CS 리포트·
 * 배송현황·배송현황 카운터는 home.php 나 gen-menu.py 어디에도 없다 - 완전히
 * 별도 레거시 시스템(banana_custom DB 를 쓰는 화면들)에서 손으로 옮겨 붙인
 * 것이다(원래는 전부 'xadm 통계' 섹션 하나였다가 요청에 따라 나눴다:
 * 방문자·매출·주문·애드워즈·신규가입자만 '통계'에 남고, CS 리포트·배송현황·
 * 배송현황 카운터는 '물류센터'로 옮겼다). 스크립트가 이 화면들을 전혀
 * 모르므로, 재생성해도 안 돌아온다 - 고치거나 늘릴 땐 이 파일을 직접 고치는
 * 수밖에 없다. 배송현황 두 개는 옮기며 roles 가 ['admin']에서 물류센터의
 * ['admin','product']로 바뀌어 product 등급도 새로 보게 됐다 (의도된
 * 부수효과 - 요청 당시 확인 필요).
 *
 * CS 리포트는 처음엔 'Custom Service'라는 자기 섹션(roles: ['admin'])을
 * 따로 갖고 있었다 (2026-09-02: 요청으로 그 섹션을 없애고 '물류센터'로
 * 합쳤다 - 섹션 key 는 한 번 쓰면 저장된 계정 데이터 때문에 못 바꾸므로
 * 'csReport' 는 완전히 폐기했다, authz.ts/AdminAccountsPage 에도 안 남긴다).
 * 그 시점에 sec:csReport 를 가진 계정은 없어서 옮겨줄 데이터가 없었다. 물류
 * 센터로 옮기며 roles 가 ['admin']에서 물류센터의 ['admin','product']로
 * 바뀌어 product 등급도 메뉴에서 새로 보게 됐다(의도된 부수효과) - 서버 쪽도
 * 같은 섹션의 배송현황과 똑같이 admin/sec:logistics 로 통일했다(레거시
 * product 리터럴은 이 섹션 API 를 원래부터 못 열었다 - xadm/index.ts 참고).
 *
 * 예외 3: '기타' 는 원래 home.php 의 섹션 이름이었지만(결제 관련 항목만 모여
 * 있었다) '결제관리'로 이름을 바꿨다. 대신 콘텐츠기획의 외부 도구 3개(TV바나나
 * 재설정·면접용 MBTI·면접용 DISC)와 성인인증 프리패스 토큰, 그리고 옛 해외영업팀의
 * 주문변환 도구 2개(쿠팡주문변환·사방넷주문변환)를 묶어 새 '기타' 섹션을 만들었다
 * - 요청에 따른 수동 재배치라 재생성해도 안 돌아온다. 쿠팡·사방넷 주문변환은
 * roles 가 ['admin','product']에서 이 섹션의 ['admin','offline','product']로
 * 바뀌어, offline 등급도 새로 보게 됐다 (의도된 부수효과 - 요청 당시 확인 필요).
 *
 * 예외 4: '해외영업팀'은 '상품관리 Ⅲ'로 이름을 바꿨다(위 주문변환 2개를 뺀
 * 나머지 4개만 남는다) - 이것도 수동 재배치라 재생성해도 안 돌아온다. 순서도
 * '상품관리 Ⅱ' 바로 다음으로 옮겨(요청에 따라) 상품관리 Ⅰ·Ⅱ·Ⅲ 가 나란히
 * 붙어 있다.
 *
 * 예외 5: '체험단' 섹션을 없앴다 - 항목 3개(체험단 현황·체험단 현황(옵션)·
 * 페이지 통계)를 '콘텐츠기획' 끝에 옮기고 섹션 자체를 지웠다. roles 가
 * ['admin','product']에서 콘텐츠기획의 ['admin','offline','product']로 바뀌어,
 * offline 등급도 새로 보게 됐다 (의도된 부수효과 - 요청 당시 확인 필요).
 * (2026-09-02: 요청으로 외부 도구 2개(포토후기 썸네일 제작·포토후기 워터마크
 * 추가)를 그 뒤로, 콘텐츠기획 맨 끝으로 다시 옮겼다 - 자주 안 쓰여서.) 또한
 * '재고 조정(모바일전용)'(물류센터)은 메뉴에서만이 아니라 통째로 없앴다 -
 * server/src/modules/reports/report.registry.ts 의 'inventory-adjust' 정의도
 * 같이 지웠다. 원래 이 둘은 home.php 파생(레거시 링크 자동 연결)이라 나중에
 * 정확한 home.php 로 재생성하면 '재고 조정(모바일전용)'은 사라지지 않고 PHP
 * 레거시 링크로 되돌아온다 - 다시 지우려면 이 파일과 report.registry.ts 를
 * 또 손으로 고쳐야 한다.
 *
 * 예외 6: '네트워크 광고 현황' 섹션(2026-09-11)은 home.php 에도 gen-menu.py 에도
 * 없다 - 레거시 /xadm 의 report_network_test_frame(_main).php · report_network.php
 * (원본 화면은 어느 메뉴에도 없어 북마크로만 들어갔다)를 옮기며 손으로 붙였다.
 * '통계'처럼 admin 전용이고, 관리자 계정 화면에서 sec:network 로 따로 줄 수 있다.
 * 재생성해도 안 돌아오므로 고치거나 늘릴 땐 이 파일을 직접 고친다.
 * (2026-09-14: 같은 레거시 묶음의 나머지 네 화면 - report_network_referer.php ·
 * report_network_referer_group.php · report_network_referer_site.php ·
 * report_network_adinfo.php - 를 마저 옮겨 항목 4개를 더했다. 순서는 레거시
 * network_menu.php 의 가로 메뉴 그대로다. 네 화면 모두 읽기 전용이라, 원본에
 * 딸려 있던 등록·수정 팝업 network_site_add/modify.php ·
 * network_adinfo_add/modify.php 는 아직 안 옮겼다.)
 *
 * 예외 7: '나래 리스트'와 '상품순위 분석기' 를 '상품관리 Ⅱ' 에서 '상품관리 Ⅲ' 로
 * 옮겼다(2026-09-16 요청). 두 섹션의 roles 가 달라서 **offline 등급은 이 두 항목을
 * 더 이상 보지 못한다**(의도된 부수효과 - 요청 당시 확인 필요). sec:product2 만
 * 가진 계정도 마찬가지고, 화면으로 바로 들어가도 Layout 의 섹션 가드에 막힌다.
 * 수동 재배치라 재생성해도 안 돌아온다.
 *
 * 섹션 이름·순서·항목 순서가 원본과 같다. 쓰던 사람이 위치로 메뉴를 기억하기
 * 때문에, 보기 좋게 재배열하지 않았다 (위 예외 3 은 명시적 재배치 요청).
 *
 * 항목은 네 가지 중 하나다.
 *   to       - 이관 완료. React 라우트로 간다.
 *   legacy   - 아직 레거시 PHP 화면. 그쪽으로 넘긴다 (스트랭글러).
 *   external - 다른 호스트로 나가는 링크. 원본도 새 창으로 열었다.
 *   disabled - 원본이 클릭 시 alert 만 띄우던 항목.
 *
 * roles 는 원본의 $xtype 분기다 (home.php:22, 96, 164).
 */

export interface MenuItem {
  name: string;
  /** 이관된 화면의 React 경로 */
  to?: string;
  /** 미이관 레거시 PHP 경로 */
  legacy?: string;
  /** 다른 호스트 */
  external?: string;
  /** 원본이 alert 로 막아두던 항목. 값은 그 안내문. */
  disabled?: string;
  /** 전체 메뉴(HomePage)에는 보이되, 화면 안 상단 nav(Layout)에서는 뺀다. */
  hideFromTopNav?: boolean;
}

export interface MenuSection {
  title: string;
  /**
   * 안정적인 섹션 식별자. `sec:<key>` 형태로 xadmin_account.authtype 에 저장되어
   * (web/src/pages/AdminAccountsPage.tsx, server/src/modules/reports/authz.ts 의
   * ALL_SECTION_KEYS 와 반드시 같아야 한다) 계정별로 섹션을 하나씩 독립적으로
   * 켜고 끌 수 있게 한다. title 은 화면 문구라 바뀔 수 있지만 key 는 한 번 쓰면
   * 안 바뀐다 - 저장된 계정 데이터가 이 값을 참조하기 때문이다.
   */
  key: string;
  /** 이 섹션을 볼 수 있는 authtype (원본 $xtype 분기와 같다, 레거시 admin_login 계정용) */
  roles: string[];
  items: MenuItem[];
}

export const MENU: MenuSection[] = [
  {
    title: '상품관리 Ⅰ',
    key: 'product1',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '상품엑셀/신상품체크', to: '/reports/category-excel' },
      { name: '누락체크', to: '/lookup/code-stock-check' },
      { name: '상품정렬 모니터링', to: '/reports/item-orders-log' },
      { name: '혜택/무혜택 오류', to: '/reports/check-benefit-soldout' },
      { name: '상품정렬확인', to: '/reports/category-orderby' },
      { name: '단종 여부 확인', to: '/lookup/soldout-check' },
      { name: '무혜택 코드 찾기', to: '/lookup/benefit-code' },
      { name: '단일 카테고리 등록 상품 찾기', to: '/reports/check-category-single' },
    ],
  },
  {
    title: '상품관리 Ⅱ',
    key: 'product2',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '종합 품절체크', to: '/lookup/soldout-check-all' },
      { name: '리얼돌 주문확인', to: '/reports/realdoll-orders' },
      { name: '제조사 코드 중복 확인', to: '/reports/item-code-duplicate' },
      { name: '입고 리스트', to: '/lookup/inout-history' },
      { name: '적립금 확인', to: '/reports/tsumitate-list' },
      { name: '마진율 확인', to: '/reports/dome-price' },
      { name: '신상품 필터링', to: '/reports/zaiko-filter' },
      { name: '재고 확인', to: '/reports/zaiko-stock' },
    ],
  },
  {
    title: '상품관리 Ⅲ',
    key: 'product3',
    roles: ['admin', 'product'],
    items: [
      { name: '신상품 예약 상품관리', to: '/reports/reservation-goods' },
      { name: '노출메뉴관리(베스트)', to: '/reports/cate-best' },
      { name: '카테고리 랭킹 순위', to: '/reports/category-rank' },
      { name: '상품 랭킹 순위', to: '/reports/product-rank' },
      // 아래 둘은 2026-09-16 요청으로 '상품관리 Ⅱ' 에서 옮겨왔다 (예외 7).
      { name: '나래 리스트', to: '/reports/nare-list' },
      // 외부 도구라 섹션 맨 아래에 둔다 - 옮기기 전에도 그 자리였다.
      { name: '상품순위 분석기', external: 'https://api.bananamall.co.kr/best_product/' },
    ],
  },
  {
    title: '콘텐츠기획',
    key: 'content',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '이벤트 관리', to: '/reports/event-list' },
      { name: '이벤트상품 판매 분석', to: '/reports/sales-analysis' },
      { name: '체험단 현황', to: '/reports/exp-applicants' },
      { name: '체험단 현황(옵션)', to: '/reports/exp-applicants-option' },
      { name: '페이지 통계', to: '/reports/exp-daily-signup' },
    ],
  },
  {
    // 콘텐츠기획에 섞여 있던 리뷰 관련 항목 4개를 모아 새로 만든 섹션
    // (요청: 2026-09-04). roles 는 옮겨오기 전 콘텐츠기획과 같다.
    title: '리뷰 관리',
    key: 'review',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '리뷰 관리', to: '/reports/review-board' },
      { name: '리뷰수 체크', to: '/reports/review-count' },
      { name: '포토후기 썸네일 제작', external: 'https://api.bananamall.co.kr/thumb_watermark/' },
      { name: '포토후기 워터마크 추가', external: 'https://api.bananamall.co.kr/item_watermark/' },
    ],
  },
  {
    title: '매장용',
    key: 'offlineStore',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '오프라인', to: '/reports/offline-cate' },
      { name: '카테고리별 순서확인', to: '/reports/best-order-check' },
      { name: '매장등록여부 체크', to: '/lookup/soldout-check' },
      { name: '매장 일일 타임테이블', to: '/offline/timetable' },
      { name: '오프라인 판매통계', to: '/offline/sales' },
      // home.php 에 없는 신규 화면이다 (2026-10-08 요청) - 재생성해도 안
      // 돌아오므로 이 파일을 직접 고친다. 매장 POS(SQL Server) dbo.Goods 의
      // BarCode1 을 xadmin 바코드로 채운다.
      { name: '포스시스템 재고연동', to: '/offline/inven-sync' },
      { name: '고객 적립금 확인', to: '/reports/member-point' },
    ],
  },
  {
    title: '결제관리',
    key: 'payment',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '입금건 관리', to: '/reports/payment-bank' },
      { name: '정기결제 관리', to: '/reports/payment-recurring' },
      { name: '카드결제 관리', to: '/reports/payment-card' },
    ],
  },
  {
    title: '기타',
    key: 'etc',
    roles: ['admin', 'offline', 'product'],
    items: [
      { name: '성인인증 프리패스 토큰', to: '/tokens/freepass' },
      { name: 'TV바나나 재설정', external: 'http://tv2.bananamall.co.kr:80/reboot.html' },
      { name: '면접용 MBTI', external: 'https://api.bananamall.co.kr/mbti/' },
      { name: '면접용 DISC', external: 'https://api.bananamall.co.kr/personal/' },
      { name: '쿠팡주문변환', external: 'https://api.bananamall.co.kr/coupang/' },
      { name: '사방넷주문변환', external: 'https://api.bananamall.co.kr/sabangnet/' },
    ],
  },
  {
    title: '마케팅',
    key: 'marketing',
    roles: ['admin', 'product'],
    items: [
      { name: '신규가입 전환', to: '/join-stats' },
      { name: '신규가입 전환(요일별)', to: '/join-stats/weekday' },
      { name: '도메인 랭킹 체크', to: '/imports/domains' },
      // 레거시 partner.bananamall.co.kr/util/partners_report.php 를 옮긴 화면
      // (2026-09-29). 원본은 이 관리자와 별개로 자기만의 비밀번호 한 줄로 막혀
      // 있었다 - 옮기면서 그 문을 없애고 이 관리자의 '마케팅' 섹션 권한을 따른다.
      { name: '도메인 모니터링', to: '/reports/partners_report' },
      { name: 'GA입력폼(클릭금지)', to: '/imports/ga' },
      { name: '파트너 랜딩수정', to: '/reports/partner-landing' },
      { name: '이메일다운', to: '/exports/emails' },
      // 원본 ../xadmin/marketing/outmember_email.php 이관 (2026-10-01).
      { name: '회원탈퇴목록', to: '/marketing/outmember_email' },
      // 'BNN문의'(https://api.bananamall.co.kr/bnngroup/read?api_key=...)는 지금
      // 쓰지 않아 메뉴에서 뺐다 (2026-09-29 요청). 외부 링크라 이쪽에 지울 코드는
      // 없고, 다시 쓰게 되면 이 줄을 되살리면 된다.
    ],
  },
  {
    title: '통계',
    key: 'stats',
    roles: ['admin'],
    items: [
      { name: '방문자', to: '/xadm/visits' },
      { name: '매출', to: '/xadm/sales' },
      { name: '주문', to: '/xadm/orders' },
      // 애드워즈는 같은 자료(banana.shop_stats_adw)를 두 화면으로 본다 (2026-09-29 요청).
      //   애드워즈 성과 - 원래 '애드워즈 현황'이던 요약·추세 화면. 이름과 경로를 바꿨다.
      //   애드워즈 현황 - 원본 report_adw.php 의 표를 그대로 옮긴 새 화면.
      { name: '애드워즈 성과', to: '/xadm/adwords-performance' },
      { name: '애드워즈 현황', to: '/xadm/adwords' },
      { name: '신규가입자', to: '/xadm/members' },
    ],
  },
  {
    title: '물류센터',
    key: 'logistics',
    roles: ['admin', 'product'],
    items: [
      { name: '출고량 조사', to: '/reports/outbound-work' },
      { name: '배송현황', to: '/logistics' },
      { name: '배송현황 카운터', to: '/logistics/counter' },
      { name: 'CS 리포트', to: '/xadm/cs-report' },
    ],
  },
  {
    title: '랜덤박스',
    key: 'lottery',
    roles: ['admin', 'product'],
    items: [
      { name: 'F카테고리관리', to: '/lottery/categories' },
      { name: 'F랜덤박스관리', to: '/lottery/products' },
      { name: 'F오나홀관리', to: '/fanza/products' },
      { name: 'F주문관리', to: '/lottery/orders' },
      { name: 'F고객별주문', to: '/reports/lottery-orders-by-member' },
      { name: 'F주문통계(개요)', to: '/stats/lottery' },
      { name: 'F주문통계(상세)', to: '/stats/lottery/month' },
      { name: 'F랜덤박스별상세', to: '/stats/lottery/box' },
      { name: 'F알림등록', to: '/reports/lottery-alarm' },
      { name: 'FANZA専用', external: 'https://partner2.bananamall.co.kr/xadmin/home.php', hideFromTopNav: true },
    ],
  },
  {
    title: '바나나몰 랜덤박스',
    key: 'randombox',
    roles: ['admin', 'product'],
    items: [
      { name: 'N카테고리관리', to: '/randombox/categories' },
      { name: 'N랜덤박스관리', to: '/randombox/products' },
      { name: 'N주문관리', to: '/randombox/orders' },
      { name: 'N고객별주문', to: '/reports/randombox-orders-by-member' },
      { name: 'N당첨현황 대시보드', to: '/reports/randombox-prize-ranking' },
      { name: 'N주문통계(개요)', to: '/stats/randombox' },
      { name: 'N랜덤박스별상세', to: '/stats/randombox/box' },
      { name: 'N실재고현황', to: '/randombox/zaiko' },
      { name: 'N이미지생성1', external: 'https://api.bananamall.co.kr/rank/', hideFromTopNav: true },
      { name: 'N이미지생성2', external: 'https://api.bananamall.co.kr/display/', hideFromTopNav: true },
      // 2026-10-19 요청 - 메두사몰 관리자의 배송비 설정(medusa.cooltrack.jp/manage/
      // shipping-fees)을 옮긴 화면. 메두사몰과 연동하지 않는 별개 시스템이다.
      // home.php 에 없어 gen-menu.py 의 EXTRA 로 붙는다.
      { name: '지역별배송비', to: '/randombox/shipping-fees' },
    ],
  },
  {
    title: '사이트관리',
    key: 'siteManagement',
    roles: ['admin', 'product'],
    items: [
      { name: '무통장 미입금자', to: '/reports/payment-nopayment' },
      { name: '상품 오류(가격) 체크', to: '/reports/check-option-price' },
      { name: '동영상 아이콘체크(미연결)', to: '/reports/check-movie-icon' },
      { name: '인터넷 진흥원(탈퇴처리)', to: '/site/member-out-check' },
    ],
  },
  {
    // 2026-09-11, 레거시 /xadm report_network*.php 이관 (예외 6) - home.php 에 없는 섹션이다.
    // 항목 순서는 레거시 network_menu.php 의 가로 메뉴와 같다.
    title: '네트워크 광고 현황',
    key: 'network',
    roles: ['admin'],
    items: [
      { name: '광고 현황', to: '/network/report' },
      { name: '리퍼러 목록', to: '/network/referers' },
      { name: '리퍼러 통계', to: '/network/referer-stats' },
      { name: '광고 사이트', to: '/network/sites' },
      { name: '계정정보', to: '/network/adinfo' },
    ],
  },
  {
    // 2026-09-05, Redis 를 새로 설치하며 요청 - home.php 에 없는 신규 기능 섹션이다.
    title: '서버체크',
    key: 'serverCheck',
    roles: ['admin'],
    items: [
      { name: 'Redis 상황체크', to: '/server-check/redis' },
      { name: '배치관리', to: '/server-check/batch' },
      { name: '문자 발송 이력', to: '/server-check/sms-log' },
    ],
  },
  {
    title: '설정',
    key: 'settings',
    roles: ['admin'],
    items: [
      { name: '관리자 계정', to: '/admin-accounts' },
      { name: '화이트 IP 관리', to: '/whitelist' },
    ],
  },
];

/**
 * authtype 을 등급 배열로 푼다.
 *
 * admin_login(레거시) 계정은 값이 하나뿐이라 그대로 배열 하나짜리가 된다.
 * xadmin_account(신규, 관리자 계정 등록 화면) 계정은 등급을 여러 개 등록할
 * 수 있어서 "admin,product" 처럼 쉼표로 이어 온다 - 서버
 * (reports/authz.ts 의 parseRoles)와 같은 규칙으로 여기서도 나눈다.
 */
export function parseRoles(authtype: string | null | undefined): string[] {
  if (!authtype) return [];
  return authtype.split(',').map((r) => r.trim()).filter(Boolean);
}

/**
 * 섹션 하나를 개별로 부여하는 토큰의 접두어. `sec:product1` 처럼 저장된다
 * (AdminAccountsPage.tsx, server/src/modules/reports/authz.ts 와 반드시 같아야 한다).
 */
export const SEC_PREFIX = 'sec:';

/**
 * 이 계정이 볼 수 있는 섹션을 남긴다.
 *
 * 두 가지 값 체계가 섞여 올 수 있다.
 *  - `sec:<key>` (신규, AdminAccountsPage 에서 섹션을 하나씩 골라 저장한 값):
 *    그 key 와 같은 섹션만 정확히 켠다 - 같은 등급을 쓰는 다른 섹션이 딸려
 *    켜지지 않는다.
 *  - 레거시 등급(admin/offline/product/... , admin_login 계정과 예전 방식으로
 *    등록된 xadmin_account 계정): 원본 home.php 의 $xtype 분기와 같이, roles 가
 *    겹치는 섹션을 전부 켠다.
 */
export function sectionsFor(authtype: string | null | undefined): MenuSection[] {
  const roles = parseRoles(authtype);
  if (roles.length === 0) return [];
  const sectionKeys = new Set(
    roles.filter((r) => r.startsWith(SEC_PREFIX)).map((r) => r.slice(SEC_PREFIX.length)),
  );
  const legacyRoles = roles.filter((r) => !r.startsWith(SEC_PREFIX));
  return MENU.filter(
    (s) => sectionKeys.has(s.key) || (legacyRoles.length > 0 && s.roles.some((r) => legacyRoles.includes(r))),
  );
}

/**
 * 지금 보고 있는 경로가 속한 섹션을 찾는다.
 * 상세 화면(/lottery/orders/123)도 목록(/lottery/orders)의 섹션으로 친다.
 */
export function sectionOf(pathname: string): MenuSection | undefined {
  let best: { section: MenuSection; len: number } | undefined;
  for (const section of MENU) {
    for (const item of section.items) {
      if (!item.to) continue;
      if (pathname === item.to || pathname.startsWith(item.to + '/')) {
        if (!best || item.to.length > best.len) best = { section, len: item.to.length };
      }
    }
  }
  return best?.section;
}

/**
 * 상단 메뉴에서 지금 경로에 맞는 항목 하나를 고른다.
 * 경로가 접두어로 겹치는 두 항목(예: /stats/randombox 와 /stats/randombox/box)
 * 중에서는 더 긴 쪽만 고른다 - 안 그러면 NavLink 기본 접두어 매칭으로 둘 다
 * 동시에 활성화된다.
 */
export function activeItemTo(pathname: string, items: MenuItem[]): string | undefined {
  let best: string | undefined;
  for (const item of items) {
    if (!item.to) continue;
    if (pathname === item.to || pathname.startsWith(item.to + '/')) {
      if (!best || item.to.length > best.length) best = item.to;
    }
  }
  return best;
}
